import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import InfoArea from 'components/InfoArea/InfoArea.jsx';
import how1 from 'assets/img/clipboard.png';
import how2 from 'assets/img/ebook.png';
import how3 from 'assets/img/credit-card.png';
import how4 from 'assets/img/service.png';

import productStyle from 'assets/jss/material-kit-react/views/landingPageSections/productStyle.jsx';
import { CalendarToday, CreditCard } from '@material-ui/icons';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import * as actions from '../../actions';
import { APP_NAME } from '../../utils/config/constants';

class AboutContent extends React.Component {
    render() {
        const { classes, banners } = this.props;

        const { formatMessage } = this.props.intl;
        return (
            <div className={classes.section + ' how-it-work-section custom-bg'}>
                <div className={classes.container}>
                    <GridContainer justify="center">
                        <GridItem xs={12} sm={12} md={8}>
                            <div className="col-12 com-title">
                                <h2>How it Works?</h2>

                                <p className={classes.description}>
                                    <FormattedMessage
                                        id="about.description"
                                        defaultMessage={`${APP_NAME} is an on-demand app platform that will
                                provide you advanced on-demand clone scripts
                                that are fully customized as per your business
                                requirements.`}
                                    />
                                </p>
                            </div>
                        </GridItem>
                    </GridContainer>
                </div>
                <div>
                    <div className={classes.container}>
                        <div className="how-it-works-row">
                            <div className="row">
                                <div className="col-md-3 col-lg-3 col-sm-12 col-xs-12 how-it-col-1 how-it-col-1-after">
                                    <div className="how-it-works-img">
                                        <div className="step-name"> 01</div>
                                        <img
                                            src={how1}
                                            alt={formatMessage({
                                                id: 'about.registerYourself'
                                            })}
                                        />
                                    </div>

                                    <InfoArea
                                        className="how-it-info"
                                        title={formatMessage({
                                            id: 'about.registerYourself'
                                        })}
                                        description={formatMessage({
                                            id: 'about.registerDescription'
                                        })}
                                        iconColor="info"
                                        vertical
                                    />
                                </div>

                                <div className="col-md-3 col-lg-3 col-sm-12 col-xs-12 how-it-col-2 how-it-col-2-after">
                                    <div className="how-it-works-img">
                                        <div className="step-name"> 02</div>
                                        <img src={how2} alt="bookservice" />
                                    </div>

                                    <InfoArea
                                        className="how-it-info"
                                        title={formatMessage({
                                            id: 'about.bookservice'
                                        })}
                                        description={formatMessage({
                                            id: 'about.bookservicedescription'
                                        })}
                                        icon={CalendarToday}
                                        iconColor="success"
                                        vertical
                                    />
                                </div>

                                <div className="col-md-3 col-lg-3 col-sm-12 col-xs-12 how-it-col-2 how-it-col-2-after">
                                    <div className="how-it-works-img">
                                        <div className="step-name">03</div>
                                        <img src={how3} alt="payvia" />
                                    </div>

                                    <InfoArea
                                        className="how-it-info"
                                        title={formatMessage({
                                            id: 'about.payvia'
                                        })}
                                        description={formatMessage({
                                            id: 'about.payviadescription'
                                        })}
                                        icon={CreditCard}
                                        iconColor="danger"
                                        vertical
                                    />
                                </div>

                                <div className="col-md-3 col-lg-3 col-sm-12 col-xs-12 how-it-col-1">
                                    <div className="how-it-works-img">
                                        <div className="step-name">04</div>
                                        <img src={how4} alt="LetProviders" />
                                    </div>

                                    <InfoArea
                                        className="how-it-info"
                                        title={formatMessage({
                                            id: 'about.finalstep'
                                        })}
                                        description={formatMessage({
                                            id: 'about.finalstepdescription'
                                        })}
                                        icon={CalendarToday}
                                        iconColor="success"
                                        vertical
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
// const mapStateToProps = ({ settings }) => {
//     return { settings: settings };
// };
const composedComponent = compose(
    withStyles(productStyle),
    connect(
        null,
        actions
    )
);
export default composedComponent(injectIntl(AboutContent));



// WEBPACK FOOTER //
// ./src/components/About/AboutContent.js